import React from 'react';

import './style.scoped.scss';
import { Link } from 'react-router-dom';
import { TranslateWorkaround, displayDocVersion, pageHasContent, ROUTES } from '../../assets/constants/strings';
import { connect } from 'react-redux';
import { findFirstPageWithContent, setCurrentPage } from '../../store/Document/documentActions';

const Breadcrumbs = ({
  document,
  page, //&bull;
  isPreview,
  setCurrentPage,
  handleLevelSelected,
}) => {
  if (!page || !document || !document.levelOne || !document.levelTwo)
    return <React.Fragment></React.Fragment>;

  let parentPage = null;
  let gParentPage = null;

  if (page.parentId !== null) {
    parentPage = document.pages.filter((docPage) => docPage.id === page.parentId)[0];

    if (parentPage && parentPage.parentId !== null) {
      gParentPage = document.pages.filter((docPage) => docPage.id === parentPage.parentId)[0];
    }
  }

  const firstPage = findFirstPageWithContent(document.pages);
  return (
    <nav>
      <ol className="breadcrumb">
        <li
          className={`breadcrumb-item${TranslateWorkaround(document.levelOne.Title)}`}
          title={document.levelOne.Title}
          onClick={() => handleLevelSelected(document.levelOne, 'levelOne')}
        >
          <p>{document.levelOne.Title}</p>
        </li>
        <li
          className="breadcrumb-item mobile-hide"
          title={document.levelTwo.Title}
          onClick={() => handleLevelSelected(document.levelTwo, 'levelTwo')}
        >
          <p>{document.levelTwo.Title}</p>
        </li>
        {document.levelThree && (
          <li
            className="breadcrumb-item mobile-hide"
            title={document.levelThree.Title}
            onClick={() => handleLevelSelected(document.levelThree, 'levelThree')}
          >
            <p>{document.levelThree.Title}</p>
          </li>
        )}
        {document.levelFour && (
          <li
            className="breadcrumb-item mobile-hide"
            title={document.levelFour.Title}
            onClick={() => handleLevelSelected(document.levelFour, 'levelFour')}
          >
            <p>{document.levelFour.Title}</p>
          </li>
        )}
        <li className="breadcrumb-item" title="Go to first page of document" id="docTitle">
          <Link
            to={
              isPreview
                ? ROUTES.PREVIEW(firstPage.documentSlug, firstPage.slug)
                : ROUTES.DOCUMENT(firstPage.documentSlug, firstPage.slug)
            }
            onClick={() => setCurrentPage(firstPage, document.pages)}
          >
            {displayDocVersion(document)}
          </Link>
        </li>
        {gParentPage && (
          <li className="breadcrumb-item mobile-hide" title={gParentPage.title}>
            {pageHasContent(gParentPage.HTMLContent) ? (
              <Link
                to={
                  isPreview
                    ? ROUTES.PREVIEW(gParentPage.documentSlug, gParentPage.slug)
                    : ROUTES.DOCUMENT(gParentPage.documentSlug, gParentPage.slug)
                }
                onClick={() => setCurrentPage(gParentPage, document.pages)}
              >
                <p>{gParentPage.title}</p>
              </Link>
            ) : (
              <p>{gParentPage.title}</p>
            )}
          </li>
        )}
        {parentPage && (
          <li className="breadcrumb-item mobile-hide" title={parentPage.title}>
            {pageHasContent(parentPage.HTMLContent) ? (
              <Link
                to={
                  isPreview
                    ? ROUTES.PREVIEW(parentPage.documentSlug, parentPage.slug)
                    : ROUTES.DOCUMENT(parentPage.documentSlug, parentPage.slug)
                }
                onClick={() => setCurrentPage(parentPage, document.pages)}
              >
                <p>{parentPage.title}</p>
              </Link>
            ) : (
              <p>{parentPage.title}</p>
            )}
          </li>
        )}
      </ol>
    </nav>
  );
};

const mapStateToProps = (state) => ({
  document: state.document.currentDocument,
  page: state.document.currentPage,
  isPreview: state.client.isPreview,
});

const mapDispatchToProps = { setCurrentPage };

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(Breadcrumbs);
